import React, { useMemo, useCallback } from 'react';
import { Platform } from 'react-native';
import { useTranslation } from '@/hooks/useTranslation';
import { useRouter } from 'expo-router';
import SignupForm from '@/components/Forms/SignupForm';
import { APP_NAME } from '@/constants/config';
import AuthPage from '@/components/Pages/AuthPage';
import { useAuthStore } from '@/store';
import GhostSignupForm from '@/components/Forms/GhostSignupForm';
import MetaHead from '@/components/MetaHead';

function SignupRoute() {
  const { t } = useTranslation();
  const router = useRouter();
  const isGhost = useAuthStore(state => state.user?.flags?.isGhost);
  
  // Memoize handlers
  const handleLogoPress = useCallback(() => {
    router.push('/');
  }, [router]);

  // Memoize title
  const title = useMemo(() => 
    t('auth.signup.title').replace('%APP_NAME%', APP_NAME),
    [t]
  );

  // show different form if ghost
  if (isGhost && Platform.OS === 'web') {
    return (
      <AuthPage
        title='Ready to unlock all features?'
        subtitle='Create your account to save your progress and access all features.'
        onLogoPress={handleLogoPress}
      >
        <MetaHead noindex
          title="Sign Up"
          description="Unlock the full potential of Gab AI. Complete your registration to save your progress, access premium features, and enjoy supercharged AI interactions across multiple models."
        />
        <GhostSignupForm />
      </AuthPage>)
  }

  return (
    <AuthPage
      title={title}
      subtitle={t('auth.signup.subtitle')}
      onLogoPress={handleLogoPress}
    >
      <MetaHead noindex
        title="Sign Up"
        description="Join Gab AI today and get access to multiple AI models in one platform. Create your account to start engaging top AI models and more with flexible pricing options."
      />
      <SignupForm replaceUrl="/(app)/app" />
    </AuthPage>
  );
};

export default React.memo(SignupRoute);
